var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react'; // tslint:disable-line

import styled, { css, withTheme } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('loader');
import { breakpoints, theme } from '@shapeable/theme';
import { ClipLoader as Spinner } from 'react-spinners';
export var LoaderDefaultProps = {
  spinnerColor: 'primary',
  spinnerSize: 8,
  message: 'Please wait...',
  spaceUnits: 4,
  inverted: false
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    flex-direction: column;\n  "], ["\n    display: flex;\n    align-items: center;\n    font-family: ", ";\n    flex-direction: column;\n  "])), theme.FONT('sans')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    flex-direction: row;\n    align-items: center;\n  "])))
});
var SpinnerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var MessageStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    font-weight: 500;\n    color: ", ";\n\n    ", "\n  "], ["\n    margin-top: ", ";\n    font-weight: 500;\n    color: ", ";\n\n    ", "\n  "])), theme.UNIT(3), theme.COLOR('textMid'), function (props) {
    return props.inverted && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR('light'));
  }),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n    margin-top: 0px;\n  "], ["\n    ", "\n    margin-top: 0px;\n  "])), function (_a) {
    var spaceUnits = _a.spaceUnits;
    return spaceUnits && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme.UNIT(spaceUnits));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Spinner: styled(Spinner)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), SpinnerStyles),
  Message: styled.div.attrs(cls.attr('message'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles)
};

var LoaderComponent = function LoaderComponent(props) {
  var className = props.className,
      children = props.children,
      message = props.message,
      spinnerSize = props.spinnerSize,
      spaceUnits = props.spaceUnits,
      inverted = props.inverted; // theme functions return a function to evaluate the theme value on a theme object (passed in via context) 

  var spinnerColor = theme.COLOR(props.spinnerColor)(props);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Spinner, {
    size: spinnerSize,
    color: spinnerColor
  }), React.createElement(My.Message, {
    inverted: inverted,
    spaceUnits: spaceUnits
  }, children || message));
};

LoaderComponent.defaultProps = LoaderDefaultProps; // note, we internalize the React component, and always export Loader wrapped in the withTheme HOC
// (the HOC is required for the theme coloring to work)
// @ts-ignore

export var Loader = withTheme(LoaderComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;